export default __webpack_public_path__ + "menu-icon-jJz.svg";